import getQueryVariables from './getQueryVariables';

const getQueryParamFromURL = () => {
  const link = window.location.href;
  const queryString = link && link.split('?')[1] ? link.split('?')[1] : '';
  if (!queryString) return {};
  const queryParams = getQueryVariables(queryString);
  return queryParams;
};

export default getQueryParamFromURL;
